import * as React from "react"

export const ProfileFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.3 34.9q2.95-2 6.05-3.05T24 30.8q3.55 0 6.674 1.05 3.127 1.05 6.076 3.05 2.05-2.5 2.975-5.2t.925-5.7q0-7.05-4.8-11.85T24 7.35t-11.85 4.8T7.35 24q0 3 .95 5.7t3 5.2M24 25.65q-2.9 0-4.9-2t-2-4.9 2-4.9q2-2 4.9-2t4.9 2 2 4.9q0 2.95-2 4.925T24 25.65M24 44q-4.15 0-7.825-1.575t-6.375-4.3q-2.7-2.726-4.25-6.35Q4 28.149 4 24t1.575-7.8q1.575-3.65 4.3-6.35t6.35-4.275T24 4q4.149 0 7.8 1.575t6.35 4.275q2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.15-1.575 7.775t-4.275 6.35q-2.7 2.725-6.35 4.3Q28.149 44 24 44"
    ></path>
  </svg>
)
